module.exports = __webpack_public_path__ + "fonts/Montserrat-Thin.4b73d125.ttf";